import * as React from "react";
import { cn } from "@/lib/cn";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  helperText?: string;
  error?: string | null;
};

export const Input = React.forwardRef<HTMLInputElement, Props>(function Input(
  { className, label, helperText, error, id, "aria-invalid": ariaInvalid, ...props },
  ref
) {
  const reactId = React.useId();
  const inputId = id ?? reactId;
  const describedBy = error ? `${inputId}-error` : undefined;
  return (
    <div className={error ? "fieldWrap fieldWrapInvalid" : "fieldWrap"}>
      {label ? (
        <label className={cn("label", error ? "labelInvalid" : undefined)} htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <input
        ref={ref}
        id={inputId}
        className={cn("input", error ? "inputInvalid" : undefined, className)}
        aria-invalid={error ? true : ariaInvalid}
        aria-describedby={describedBy}
        {...props}
      />
      {error ? (
        <div className="fieldError" id={describedBy} role="alert">
          {error}
        </div>
      ) : helperText ? (
        <div className="helper">{helperText}</div>
      ) : null}
    </div>
  );
});
